import { MenuOptions } from 'models';
import NavMenuItem from './NavMenuItem';
import { MenuWrapper } from './NavMenu.styles';

interface MenuProps {
  options: MenuOptions[];
  totalVouchers: number;
  hasNewVouchers: boolean;
}

const NavMenu = ({ options, totalVouchers, hasNewVouchers }: MenuProps) => (
  <MenuWrapper aria-label="Navigation Menu">
    {options.map((option) => (
      <NavMenuItem
        key={option.label}
        option={option}
        totalVouchers={totalVouchers}
        hasNewVouchers={hasNewVouchers}
      />
    ))}
  </MenuWrapper>
);

export default NavMenu;
